import { extractCustomFieldValue } from '../utils/extractCustomFieldValue';
export const selectActivityFields = (state) => state.activityForm.fields;
export const selectAreActivityFieldsLoading = (state) =>
  state.activityForm.fieldsLoading;
export const selectActivityFieldsError = (state) =>
  state.activityForm.fieldsError;

export const selectActivityData = (state) => state.activityForm.activityData;
export const selectIsFetchingActivity = (state) =>
  state.activityForm.fetchActivityLoading;
export const selectFetchActivityError = (state) =>
  state.activityForm.fetchActivityError;

export const selectIsCreatingActivity = (state) =>
  state.activityForm.createActivity.loading;
export const selectCreateActivityError = (state) =>
  state.activityForm.createActivity.error;
export const selectCreateActivityFieldErrors = (state) =>
  state.activityForm.createActivity.fieldErrors;
export const selectCreateActivityResult = (state) =>
  state.activityForm.createActivity.result;
// The id of an activity whose projection is confirmed readable -- the signal to
// redirect. Distinct from the result, which is only the POST acknowledgement.
export const selectCreatedActivityId = (state) =>
  state.activityForm.createActivity.readyActivityId;

export const selectIsUpdatingActivity = (state) =>
  state.activityForm.updateActivity.loading;
export const selectUpdateActivityError = (state) =>
  state.activityForm.updateActivity.error;
export const selectUpdateActivityFieldErrors = (state) =>
  state.activityForm.updateActivity.fieldErrors;
export const selectUpdateActivityResult = (state) =>
  state.activityForm.updateActivity.result;
export const selectUpdatedActivityId = (state) =>
  state.activityForm.updateActivity.readyActivityId;

export const selectSkillsetTags = (state) =>
  state.activitySkillsetTags?.tags ?? [];
export const selectAreSkillsetTagsLoading = (state) =>
  state.activitySkillsetTags?.loading ?? false;

export const selectAssignmentMethodList = (state) =>
  state.activityAssignmentMethod?.list ?? [];
export const selectIsAssignmentMethodLoading = (state) =>
  state.activityAssignmentMethod?.loading ?? false;
export const selectAssignmentActiveTab = (state) =>
  state.activityAssignmentMethod?.activeTab;
export const selectWorkerCustomFields = (state) =>
  state.workerDetail?.workerDetail?.CustomFields || {};
export const selectPropertyDefaults = (state) => {
  const customFields = selectWorkerCustomFields(state);
  return {
    address1: extractCustomFieldValue(customFields, 'propertylocation_address1_text'),
    address2: extractCustomFieldValue(customFields, 'propertylocation_address2_text'),
    zip: extractCustomFieldValue(customFields, 'propertylocation_zip_zip'),
    state: extractCustomFieldValue(customFields, 'propertylocation_state_state'),
    county: extractCustomFieldValue(customFields, 'propertylocation_county_county'),
    city: extractCustomFieldValue(customFields, 'propertylocation_city_city'),
    country: extractCustomFieldValue(customFields, 'propertylocation_country_country'),
  };
};